import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SEARCH_TYPE, searchtypes } from '../../core/quotes.model';
import { I18nModule } from '@spartacus/core';
import { BasicSearchComponent } from './basic-search/basic-search.component';
import { AdvancedSearchComponent } from './advanced-search/advanced-search.component';
import { ProductListComponent } from './product-list/product-list.component';

@Component({
  selector: 'product-finder',
  standalone: true,
  imports: [CommonModule, BasicSearchComponent, AdvancedSearchComponent, I18nModule, ProductListComponent],
  templateUrl: './product-finder.component.html',
  styleUrl: './product-finder.component.scss',
})
export class ProductFinderComponent {
  SEARCH_TYPE = SEARCH_TYPE;
  searchtypes = searchtypes;
  currentSearchType: SEARCH_TYPE | string = SEARCH_TYPE.BASIC;

  setSearchType(type: SEARCH_TYPE | string) {
    this.currentSearchType = type;
  }
}
